'use client';
import { Icon } from '@iconify/react';
import { Menu, Tooltip } from '@mantine/core';
import Image from 'next/image';
import style from './user-profile.module.scss';
import clsx from 'clsx';
import { useBreakpoints } from '@/hooks/useBreakpoints';
import { destroySession } from '@/lib/features/session/sessionSlice';
import { useRouter } from 'next/navigation';
import { useDispatch, useSelector } from 'react-redux';
import { logout } from '@/lib/utils/login-session';
import { useSocket } from '@/hooks/useSocket';

const UserProfile = () => {
    const { xsDevice } = useBreakpoints();
    const { username, userId, accountType } = useSelector((state) => state.session);
    const router = useRouter();
    const usernameLength = username?.length;
    const usernameMaxLength = xsDevice ? 12 : 5;
    const dispatch = useDispatch();
    const { languageData } = useSelector((state) => state.language);
    const header = languageData?.text?.header;
    const { socket } = useSocket();

    const handleLogout = async () => {
        try {
            // socket.emit('presence:disconnect');
            socket.disconnect();
            await logout();
            dispatch(destroySession());
            router.push('/login');
        } catch (error) {
            console.error('Logout failed:', error);
        }
    };

    const profileBtn = (
        <Menu.Target>
            <button className="header_btn extra_space_x">
                <div className="btn_img">
                    <Image src="/images/icons/user.svg" height={18} width={18} alt="user icon" className="dark-blue-filter" style={{width: "1.125rem", height: "1.125rem"}} />
                </div>

                <div className="btn_content">
                    <span className="btn_text">
                        {usernameLength > usernameMaxLength ? `${username?.slice(0, usernameMaxLength)}...` : username}
                        <Icon icon="icon-park-outline:down" fontSize="1.125rem" className="btn_dropdown_icon" />
                    </span>
                </div>
            </button>
        </Menu.Target>
    );

    return (
        <>
            <Menu shadow="md" width={200} arrowOffset={50} arrowSize={10} withArrow position="bottom">
                {usernameLength > usernameMaxLength ? (
                    <Tooltip label={username} arrowOffset={50} arrowSize={10} withArrow position="bottom">
                        {profileBtn}
                    </Tooltip>
                ) : (
                    profileBtn
                )}

                <Menu.Dropdown>
                    <Menu.Item leftSection={<Icon icon="material-symbols:logout" fontSize="1.25rem" className={style.icon} />} className={clsx(style.logout_btn)} onClick={handleLogout}>
                        {header?.logout || 'Log Out'}
                    </Menu.Item>
                </Menu.Dropdown>
            </Menu>
        </>
    );
};

export default UserProfile;
